import { Mail, Phone, MessageCircle } from "lucide-react";
import { company, contact } from "@/data/site";
import { Dialog, DialogContent, DialogTrigger, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const mailHref = `mailto:${company.email}?subject=${encodeURIComponent(contact.mailSubject)}&body=${encodeURIComponent(contact.mailBody)}`;
const telHref = company.phoneHref;
const waHref = `${company.whatsapp}?text=${encodeURIComponent(contact.whatsappText)}`;

const Row = ({ href, external, icon: Icon, label, sub, testId }) => (
  <a
    href={href}
    {...(external ? { target: "_blank", rel: "noreferrer" } : {})}
    data-testid={testId}
    className="group flex items-center gap-4 rounded-xl border border-[color:var(--line)] bg-[color:var(--bg)] p-4 transition-colors duration-200 hover:border-[color:var(--violet)]"
  >
    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full" style={{ backgroundColor: "rgba(117,64,183,0.16)" }}>
      <Icon className="h-5 w-5" style={{ color: "var(--violet)" }} />
    </span>
    <span className="min-w-0">
      <span className="block font-medium text-[color:var(--ink)]">{label}</span>
      <span className="block text-[14px] text-[color:var(--ink-2)] truncate">{sub}</span>
    </span>
  </a>
);

export const TerminDialog = ({ className, children = "Termin anfragen", testId = "termin-trigger" }) => (
  <Dialog>
    <DialogTrigger asChild>
      <button type="button" data-testid={testId} className={className}>{children}</button>
    </DialogTrigger>
    <DialogContent
      data-testid="termin-dialog"
      className="max-w-md !rounded-2xl text-[color:var(--ink)]"
      style={{ backgroundColor: "var(--surface)", borderColor: "var(--line)" }}
    >
      <DialogHeader>
        <DialogTitle className="text-[22px] font-semibold tracking-[-0.01em] text-[color:var(--ink)]">Termin anfragen</DialogTitle>
        <DialogDescription className="text-[color:var(--ink-2)]">Wählen Sie, wie Sie uns am liebsten erreichen – wir melden uns persönlich.</DialogDescription>
      </DialogHeader>
      <div className="mt-2 space-y-3">
        <Row href={mailHref} icon={Mail} label="Per E-Mail" sub={company.email} testId="termin-option-email" />
        <Row href={telHref} icon={Phone} label="Telefon anrufen" sub={company.phone} testId="termin-option-phone" />
        <Row href={waHref} external icon={MessageCircle} label="WhatsApp" sub="Chat direkt öffnen" testId="termin-option-whatsapp" />
      </div>
    </DialogContent>
  </Dialog>
);
